import script from "./PageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeader.vue?vue&type=script&setup=true&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=d11644b8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d11644b8"]])

export default __exports__